import axios from 'axios';

const runtimeApiUrl = (): string => {
  const fromEnv = (import.meta as any).env?.VITE_API_URL;
  if (typeof fromEnv === 'string' && fromEnv.trim().length > 0) {
    return fromEnv.trim();
  }
  return '/api';
};

class DemoService {
  private baseURL: string;

  constructor() {
    this.baseURL = runtimeApiUrl();
  }

  async isDemoModeEnabled(): Promise<boolean> {
    try {
      const response = await axios.get(`${this.baseURL}/system/public/demo/status`);
      return response.data?.data?.demoModeEnabled || false;
    } catch {
      return false;
    }
  }

  async getDemoItemInfo(itemId: string): Promise<any> {
    const response = await axios.get(`${this.baseURL}/system/public/demo/item/${itemId}`);
    return response.data?.data;
  }

  async createDemoCheckout(itemId: string, quantity: number = 1, notes?: string, sapPlantNumber?: string): Promise<any> {
    const response = await axios.post(`${this.baseURL}/system/public/demo/checkout/${itemId}`, {
      quantity,
      notes,
      sapPlantNumber
    });
    return response.data?.data;
  }
}

export const demoService = new DemoService();
export default demoService;
